var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    {
      staticClass: "fill-height"
    },
    [
      _c(
        "v-skeleton-loader",
        {
          attrs: {
            loading: _vm.loading,
            type: "article"
          }
        },
        [
          _c(
            "gg-card-header",
            [
              _vm._v(" Affiliate Profile "),
              _c(
                "gg-btn",
                {
                  staticClass: "float-right",
                  attrs: {
                    primary: ""
                  },
                  on: {
                    click: _vm.triggerModal
                  }
                },
                [_vm._v(" Edit ")]
              )
            ],
            1
          ),
          _c(
            "gg-card-text",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c("div", [
                        _vm._v(" Current Classification: "),
                        _c("b", [_vm._v(_vm._s(_vm.classification))])
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.modal
        ? _c("gg-modal", {
            attrs: {
              "is-active": _vm.modal
            },
            on: {
              close: _vm.triggerModal
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "toolbar",
                  fn: function fn() {
                    return [_vm._v("Select Your Classification")]
                  },
                  proxy: true
                },
                {
                  key: "body",
                  fn: function fn() {
                    return [
                      _c("gg-select", {
                        attrs: {
                          label: "Classification",
                          items: _vm.items
                        },
                        model: {
                          value: _vm.selected,
                          callback: function callback($$v) {
                            _vm.selected = $$v
                          },
                          expression: "selected"
                        }
                      })
                    ]
                  },
                  proxy: true
                },
                {
                  key: "actions",
                  fn: function fn() {
                    return [
                      _c(
                        "gg-btn",
                        {
                          attrs: {
                            secondary: ""
                          },
                          on: {
                            click: _vm.triggerModal
                          }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _c(
                        "gg-btn",
                        {
                          attrs: {
                            primary: "",
                            loading: _vm.pending
                          },
                          on: {
                            click: _vm.changeClassification
                          }
                        },
                        [_vm._v("Save")]
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              2871818272
            )
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }